import {base} from '../../../models/base';

export default {
  namespace: 'ad',
  state:{},
//  reducers: {
//  }
  reducers: Object.assign(
    base,
    {
      setData(state, {data}){
        console.info('about/data', data);
        return { ...state, data: data};
      },
    }),
};



// WEBPACK FOOTER //
// ./src/pages/ad/models/ad.js